import styled from 'styled-components';
import { fitbitGreen } from '../../../themes';
import React, { FC } from 'react';
import { DeveloperContactProps } from './types';

interface DeveloperContactLinkProps extends DeveloperContactProps {
}

const StyledLink = styled.a`
  color: ${fitbitGreen};
`;

export const DeveloperContactLink: FC<DeveloperContactLinkProps> = ({
  label,
  onClick,
  id,
  href,
  target,
}) => (
  <StyledLink
    href={href}
    target={target}
    id={id}
    aria-label={id}
    onClick={onClick}
  >{label}</StyledLink>
);